<template>
  <img v-if="thumbnail && imgLoaded" :src="thumbnail" :alt="name">
  <img v-else-if="typeIcon" :src="picUrl" :class="typeCls" />
</template>

<script>
export default {
  name: 'FileThumbIcon',
  components: {
  },
  props: {
    name: String,
    thumbnail: String,
    typeIcon: [String, Boolean],
    space: String,
    typeCls: {
      type: String,
      default: 'type-icon'
    }
  },
  data () {
    return {
      imgLoaded: false,
      src: ''
    }
  },
  computed: {
    picUrl () {
      if (this.typeIcon) {
        return require(`@/assets/embedAppPageImg/${this.typeIcon}.png`)
      }

      return ''
    }
  },
  created () {
    if (this.thumbnail) {
      this.loadImg(this.thumbnail)
    }
  },
  watch: {
    thumbnail (val) {
      if (val) {
        this.loadImg(val)
      }
    }
  },
  methods: {
    loadImg (url) {
      this.removeImg()

      this.img = document.createElement('img')
      this.img.setAttribute('style', 'display: none')
      this.img.onload = () => {
        this.imgLoaded = true
        this.removeImg()
      }
      this.img.onerror = this.removeImg

      document.body.appendChild(this.img)
      this.img.src = url
    },
    removeImg () {
      if (this.img && document.body.contains(this.img)) document.body.removeChild(this.img)
    }
  }
}
</script>
